module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-inputtool-colours"
  }, [_c('div', {
    staticClass: "kiwi-inputtool-colours-palette",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      },
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-white",
    attrs: {
      "data-code": "00"
    },
    on: {
      "click": _vm.onColourClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-black",
    attrs: {
      "data-code": "01"
    },
    on: {
      "click": _vm.onColourClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-blue",
    attrs: {
      "data-code": "02"
    },
    on: {
      "click": _vm.onColourClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-green",
    attrs: {
      "data-code": "03"
    },
    on: {
      "click": _vm.onColourClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-light-red",
    attrs: {
      "data-code": "04"
    },
    on: {
      "click": _vm.onColourClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-brown",
    attrs: {
      "data-code": "05"
    },
    on: {
      "click": _vm.onColourClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-purple",
    attrs: {
      "data-code": "06"
    },
    on: {
      "click": _vm.onColourClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-orange",
    attrs: {
      "data-code": "07"
    },
    on: {
      "click": _vm.onColourClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-yellow",
    attrs: {
      "data-code": "08"
    },
    on: {
      "click": _vm.onColourClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-light-green",
    attrs: {
      "data-code": "09"
    },
    on: {
      "click": _vm.onColourClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-cyan",
    attrs: {
      "data-code": "10"
    },
    on: {
      "click": _vm.onColourClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-light-cyan",
    attrs: {
      "data-code": "11"
    },
    on: {
      "click": _vm.onColourClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-light-blue",
    attrs: {
      "data-code": "12"
    },
    on: {
      "click": _vm.onColourClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-pink",
    attrs: {
      "data-code": "13"
    },
    on: {
      "click": _vm.onColourClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-grey",
    attrs: {
      "data-code": "14"
    },
    on: {
      "click": _vm.onColourClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour irc-bg-colour-light-grey",
    attrs: {
      "data-code": "15"
    },
    on: {
      "click": _vm.onColourClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour kiwi-inputtools-colours-reset",
    on: {
      "click": _vm.onResetClick
    }
  }, [_c('i', {
    staticClass: "fa fa-ban",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-inputtools-colours-colour kiwi-inputtools-colours-img",
    staticStyle: {
      "background-image": "url(/static/emoticons/smile.png)"
    },
    attrs: {
      "data-code": ":D"
    },
    on: {
      "click": _vm.onImgClick
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-357ddfd1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputtools/TextStyle.vue
// module id = 484
// module chunks = 2